// Display only. Source data, API parameters and scientific matching stay unchanged.
export const genotypeLabels={het:'双杂合候选',hom:'纯合',mixed:'混合 GT'};

const messages={
    'P/V are supplied source groups, not verified ACMG classifications.':'P/V 为提供方的来源分组，不代表经核验的 ACMG 临床分级。',
    'Pipe-form GT is supplied; phase method, phase quality and family confirmation were not provided.':'原始 GT 含相位分隔符，但未提供分相方法、质量及家系确认依据。',
    'The saved reference version is no longer available; select the data explicitly again':'已保存查询所绑定的参考数据已不可用，当前查询保持原样。',
    'Only disease unit, gene, locus, phenotype and combinations are supported.':'仅支持疾病单元、基因、位点、表型及其组合查询。',
    'Intent service could not be reached after 3 attempts. Continue in manual mode.':'连续三次无法连接意图识别服务，已切换手动模式。',
};
export function uiMessage(value,fallback='操作未完成，请重试。'){
    if(!value)return fallback;
    const text=String(value);
    if(messages[text])return messages[text];
    if(text.startsWith('P/V source-group definition: '))return `P/V 来源分组定义：${text.slice('P/V source-group definition: '.length).replace(/\. Clinical classification is not inferred\.$/,'')}。不据此推断临床分级。`;
    if(text.startsWith('Supplied phase method: '))return `提供方分相方法：${text.slice('Supplied phase method: '.length).replace(/\. Family confirmation and phase quality were not supplied\.$/,'')}。未提供家系确认及相位质量。`;
    if(/[\u3400-\u9fff]/.test(text))return text;
    if(/saved.*(version|reference)|reference.*(unavailable|changed)|dataset.*(unavailable|not found)/i.test(text))return '所选或已保存的数据版本已不可用，请重新选择；当前查询不会被替换。';
    if(/three|3 attempts|3 failed/i.test(text))return '意图识别连续三次失败，已切换手动模式。';
    return fallback;
}
